module.exports = __webpack_public_path__ + "static/media/logodif2024.cc1947bf.jpeg";